import { Autocomplete, Box, FormControl, TextField } from '@mui/material';
interface Option {
  label: string;
  value: string | number;
}

interface FormikAutocompleteProps {
  disabled?: boolean;
  name: string;
  label: string;
  initialValue: string;
  fieldValue: any;
  handleChange: any;
  options: Option[];
  isErrorField: boolean;
  placeHolder: string;
}

export default function FormikAutocomplete({
  disabled = false,
  name,
  label,
  fieldValue,
  handleChange,
  placeHolder,
  options,
  initialValue,
  isErrorField
}: FormikAutocompleteProps) {

  return (
    <Box className="appointment-dropdown">
      <FormControl
        fullWidth
        sx={{
          borderRadius: '25px',
          background: 'var(--secondary-white, #fff)'
        }}
      >
        <Autocomplete
          id="combo-box-demo"
          
          onChange={handleChange}
          disablePortal
          fullWidth
          options={options}
          disabled={disabled}
          className="dropdown-select"
          freeSolo={false}
          value={fieldValue?.value || initialValue}
          renderInput={(params) => (
            <TextField
              {...params}
              error={isErrorField}
              name={name}
              label={label}
              placeholder={placeHolder}
              InputLabelProps={{
                className: 'weight-600'
              }}
              InputProps={{
                ...params.InputProps
              }}
              onChange={handleChange}
            />
          )}
        />
      </FormControl>
    </Box>
  );
}
